<template>
    <div class="">
        <div class="panel-tag">
            {{__t('SEND_INFO')}}
        </div>

        <b-overlay :show="is_active" rounded="sm">

            <button type="button" v-on:click="send_order" :disabled="is_active"
                    :class="[ is_active ? 'btn-outline-warning' : 'btn-outline-success']"
                    class="btn btn-lg waves-effect waves-themed">

                <span class="fal mr-1" :class="[ is_active ? 'fa-exclamation-triangle' : 'fa-download']"></span>
                {{__t('MANUAL_SEND')}}
            </button>

            <button type="button" v-on:click="print_order" class="btn btn-lg waves-effect waves-themed btn-outline-warning" :disabled="is_print">
                <span class="fal mr-1" :class="[ is_print ? 'fa-exclamation-triangle' : 'fa-download']"></span>
                {{__t('PRINT_ORDER')}}
            </button>


            <button v-if="is_syrve" type="button" v-on:click="check_order" :disabled="is_check_work" :class="[ is_check_work ? 'btn-outline-warning' : 'btn-outline-warning']" class="btn btn-lg waves-effect waves-themed">
                <span class="fal mr-1" :class="[ is_check_work ? 'fa-exclamation-triangle' : 'fa-download']"></span>
                {{__t('CHECK_STATUS')}}
            </button>

        </b-overlay>

        <div class="logs_data">
            <order_logs :logs="order_logs" :cur_provider="pos_provider" v-if="order_logs.length > 0"></order_logs>
        </div>

    </div>
</template>

<script>
import order_logs from "../order_logs/order_logs.vue";

export default {
    name: "order_log",
    components: {order_logs},
    props : {
        order : {
            type : Object
        }
    },
    data () {
        return {
            is_active : false,
            is_print : false,
            is_check_work : false,
        }
    },
    methods : {

        async print_order() {
            this.is_print = true;
            let order_id = this.order.id;

            await api.put('/internal/v1/catalog/orders/' + order_id + "/print").then(({data}) => {
                this.is_print = false;
                EventBus.$emit("reload_order_inside");

            }).catch(({response}) => {
                this.is_print = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                EventBus.$emit("reload_order_inside");
            });
        },

        async send_order ()  {
            this.is_active = true;
            let order_id = this.order.id;

            await api.patch('/internal/v1/catalog/orders/' + order_id).then(({data}) => {
                this.is_active = false;
                EventBus.$emit("reload_order_inside");

            }).catch(({response}) => {
                this.is_active = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                EventBus.$emit("reload_order_inside");
            });

        },

        async check_order() {
            this.is_check_work = true;
            let order_id = this.order.id;

            await pos_api.patch('/syrve/orders/' + order_id + "/validate_transaction").then(({data}) => {
                this.is_check_work = false;
                EventBus.$emit("reload_order_inside");
            }).catch(({response}) => {
                this.is_check_work = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                EventBus.$emit("reload_order_inside");
            });

        },
    },
    computed : {
        order_logs () {
            if(this.order.hasOwnProperty("logs")) {
                return this.order.logs;
            }

            return [];
        },

        providers () {

            if(this.order.hasOwnProperty("providers")) {
                return this.order.providers;
            }

            return {
                "agr" : "",
                "pos" : "",
            };
        },

        pos_provider() {
            let prov = this.providers.pos;
            //Fix Typo
            if(prov == 'iikocloud') {
                prov = 'iiko_cloud';
            }

            return prov;
        },

        is_syrve() {
            return this.pos_provider === 'iiko_cloud';
        },
    },
}
</script>



<style scoped>

</style>
